module.exports = __webpack_public_path__ + "media/10_Long.2d2c1fe1.mp3";